import { Component } from '@angular/core';

@Component({
  selector: 'sume-container-page',
  templateUrl: './container-page.component.html',
})
export class ContainerPageComponent {}
